import PanelSnap from 'panelsnap';

const nav = () => {
    const header = document.querySelector('.js-header');
    const nav = document.querySelector('.js-navigation');
    const menuBtn = document.querySelector('.js-open-menu');
    let menu, menuItems, panelSnapInstance;

    document.addEventListener('DOMContentLoaded', () => {
        menu = document.querySelector('.menu');
        menuItems = menu.querySelectorAll('.js-menu-item');

        panelSnapInstance = new PanelSnap({
            panelSelector: '.js-section',
            duration: 800,
        });
        panelSnapInstance.on('activatePanel', activateMenuItem);

        menuItems.forEach(menuItem => {
            menuItem.addEventListener('click', onButtonClick);
            menuItem.addEventListener('keyup', onButtonKeyUp);
        });

        document.querySelector('.js-btn-top').addEventListener('click', onButtonClick);
        document.querySelector('.js-back-to-top').addEventListener('click', onButtonClick);
        document.querySelector('.js-btn-next').addEventListener('click', onButtonClick);
        menuBtn.addEventListener('click', openMenu);
        document.querySelector('.js-close-menu').addEventListener('click', closeMenu);
        document.querySelector('.js-menu-overlay').addEventListener('click', closeMenu);
    });

    const openMenu = () => {
        nav.classList.add('is-open');
        menuBtn.setAttribute('aria-expanded', 'true');
    }

    const closeMenu = () => {
        nav.classList.remove('is-open');
        menuBtn.setAttribute('aria-expanded', 'false');
    }

    const activateMenuItem = (panel) => {
        menuItems.forEach(function (menuItem) {
            menuItem.classList.remove('is-active');
        });

        const panelName = panel.getAttribute('data-panel');
        const menuItem = menu.querySelector(`.js-menu-item[data-panel=${panelName}]`);
        menuItem.classList.add('is-active');
        setThemeColor();

        panelName === 'section-intro' ?
            header.classList.remove('header-compact') :
            header.classList.add('header-compact');
    }

    const onButtonClick = (e) => {
        const panelName = e.target.getAttribute('data-panel');
        const panel = document.querySelector(`.js-section[data-panel=${panelName}]`);
        panelSnapInstance.snapToPanel(panel);
        closeMenu();
    }

    const onButtonKeyUp = (e) => {
        if (e.keyCode === 13 || e.keyCode === 32) {
            const panelName = e.target.getAttribute('data-panel');
            const panel = document.querySelector(`.js-section[data-panel=${panelName}]`);
            const title = panel.querySelector('h2');
            if (title) {
                title.focus();
            }
        }
    }

    const setThemeColor = () => {
        const activeItem = document.querySelector('.js-menu-item.is-active');
        const panelName =activeItem.getAttribute('data-panel');
        const panel = document.querySelector(`.js-section[data-panel=${panelName}]`);
        const color = panel.getAttribute('data-color');

        header.style.backgroundColor = color;

        panel.classList.contains('theme-light') ?
            header.classList.add('theme-light') :
            header.classList.remove('theme-light');
    }
}

export default nav;
